<template>
  <drop-down-menu class="dots-settings-menu" right lazy nocaret no-flip boundary="window" v-bind="$attrs">
    <btn
      :id="btnId"
      slot="dropDownIcon"
      v-b-tooltip.hover
      fab
      icon
      :icon-name="icon"
      :size="size"
      :variant="btnVariant"
      :title="tooltipTitle"
      :class="btnClass"
      :data-cy="dataCy"
    />
    <template #dropDownContent>
      <slot name="links"></slot>
      <b-dropdown-group v-if="deleteLink">
        <b-dropdown-item variant="danger" class="text-uppercase" @click.prevent.stop="deleteMethod">
          <i class="fa fa-trash mr-2"></i>
          {{ deleteText }}
        </b-dropdown-item>
      </b-dropdown-group>
    </template>
  </drop-down-menu>
</template>

<script>
  export default {
    name: 'DotsSettingsMenu',

    components: {
      DropDownMenu: () => import('@/Molecules/DropDownMenu'),
    },

    props: {
      icon: { type: String, default: 'fa-ellipsis-v' },
      btnVariant: { type: String, default: 'light' },
      deleteLink: { type: Boolean, default: true },
      deleteLabel: { type: String, default: null },
      size: { type: String, default: 'lg' },
      deleteMethod: Function,
      tooltipTitle: String,
      btnClass: String,
      linkText: String,
      dataCy: String,
      btnId: String,
    },

    computed: {
      deleteText() {
        return this.deleteLabel || this.$t('cmrad.delete');
      },
    },
  };
</script>
